import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.71999 3.53468C3.38125 4.23401 4.4943 4.23401 5.15556 3.53468L7.70468 0.838778C8.13534 0.383322 8.86024 0.383323 9.2909 0.838779C9.68878 1.25957 9.68878 1.91785 9.2909 2.33864L5.391 6.4631C4.6019 7.29764 3.27365 7.29764 2.48456 6.4631L0.709099 4.58541C0.311218 4.16462 0.311219 3.50635 0.7091 3.08555C1.13976 2.6301 1.86466 2.6301 2.29532 3.08555L2.71999 3.53468Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }